<template>
  <div>{{ data.text }}</div>
  <v-row justify="space-between">
    <v-col v-for="(element, index) in data.props" :key="index" cols="auto" :md="Math.floor(12/(data.props.length))" class="d-flex">
      <v-text-field v-model="value[element.name]" :placeholder="element.text"></v-text-field>
    </v-col>
  </v-row>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'MultiTextboxComponent',
  props: {
    data: Object,
    baseValue: [Object, String, Array, Boolean],
  },
  data: (props) => {
    return {
      value: props.baseValue ?? {},
    }
  },
  emits: ['formModEvent'],
  watch: {
    value() {
      this.sendDataToParent()
    },
  },
  methods: {
    sendDataToParent() {
      const dataToSend = [
        {
          key: this.data.name,
          value: this.value,
        },
      ]
      this.$emit('formModEvent', dataToSend)
    },
  },
})
</script>
